import styled, { css } from 'styled-components'

import { FlexCentered, FullWidthHeight } from 'components/common/genericStyles'

export const Wrapper = styled.div`
    ${FullWidthHeight}
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    cursor: default;
`

export const Buttons = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    button:nth-child(1) {
        margin-right: 5px;
    }
`

export const Button = styled.button`
    ${FlexCentered}
    padding: 12px 16px;
    cursor: pointer;
    opacity: 0.8;

    width: 90px;
    height: 35px;

    background: ${props => (props.$secondary ? 'transparent' : '#ef5c34')};
    color: ${props => (props.$secondary ? 'black' : '#fff')};
    font-style: normal;
    font-weight: bold;

    border: 1px solid rgba(0, 0, 0, 0.12);
    box-sizing: border-box;

    box-shadow: 0px 1px 4px rgba(26, 21, 17, 0.12);
    border-radius: 24px;

    :hover {
        opacity: 1;
    }
`
